export const shareData = (data?: ShareData) => {
  if (window && navigator.share) {
    navigator
      .share(data)
      .catch((error) => console.error('Error sharing:', error));
  } else {
    alert('Sharing is not supported in this browser.');
  }
};
